import React from "react";
import "./NotfoundPage.css";

export default function NotfoundPage() {
  return <div className="notfound-page">NotfoundPage</div>;
}
